import { render, staticRenderFns } from "./BillingStep.vue?vue&type=template&id=1522555e&scoped=true"
import script from "./BillingStep.vue?vue&type=script&lang=js"
export * from "./BillingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522555e",
  null
  
)

export default component.exports